module.exports = __webpack_public_path__ + "img/close.e762937e.svg";